import React, { useContext } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import { TeamContext } from '../TeamContext';
import { MatchHome } from './match/MatchHome';
import { WorldTourHome } from './worldTour/WorldTourHome';

export const TeamPlayComponent = () => {
  const teamContext = useContext(TeamContext);
  const history = useHistory();

  if (
    !window.location.pathname.includes('match') &&
    teamContext.getCurrentMatch()
  ) {
    history.push(
      `/teams/${teamContext.getTeam().id}/play/match/${teamContext.getCurrentMatch()!.id}`
    );
  }
  return (
    <>
      <Switch>
        {/* For now, we're reducing the play function to just world tour */}
        {/* <Route exact path="/teams/:teamId/play" component={CompetitionSelect} />  */}
        {/* <Route path="/teams/:teamId/play/quickplay" component={QuickPlay} />  */}
        <Route exact path="/teams/:teamId/play">
          <Redirect to={`/teams/${teamContext.getTeam().id}/play/world-tour`} />
        </Route>
        <Route
          path="/teams/:teamId/play/world-tour"
          component={WorldTourHome}
        />
        <Route
          path="/teams/:teamId/play/match/:matchId"
          component={MatchHome}
        />
      </Switch>
    </>
  );
};
